/* eslint-disable indent */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import React from 'react';
import {
  useSelector,
  useDispatch,
} from 'react-redux';
import PropTypes from 'prop-types';
import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  useMediaQuery,
  Grid,
  CircularProgress,
  ToggleButtonGroup,
  ToggleButton,
  Button,
  IconButton,
  Typography,
  Tooltip,
  Menu,
  MenuItem,
  Divider,
  Collapse,
} from '@mui/material';
import CalendarMonth from '@mui/icons-material/CalendarMonth';
import CalendarViewMonth from '@mui/icons-material/CalendarViewMonth';
import {
  Add,
  AssignmentInd,
  CalendarViewWeek,
  FilterAlt,
  FilterAltOff,
  InfoOutlined,
  Settings,
} from '@mui/icons-material';
import theme from '../../../../utils/theme';

import BarnHorsesAutocomplete from '../../../Autocompletes/BarnHorses';
import LocationAutocomplete from '../../../Autocompletes/Locations';
import TagsAutocomplete from '../../../Autocompletes/Tags';
import { setSelectedLocation } from '../../../../redux/location/actions';
import { getTimeZoneOffset } from '../../../../utils/dateHelper';
import BarnUsersAutocomplete from '../../../Autocompletes/BarnUsers';
import { blueGrey } from '../../../../utils/brandColors';
import { getBarnUsersForAssignmentString } from '../../../../utils/scheduleHelper';
import User from '../../../User';
import HorseIcon from '../../../CustomIcons/Horse';
import * as brandColors from '../../../../utils/brandColors';
import TaskDefinitionAutocomplete from '../../../Autocompletes/TaskDefinition';

const FilterBarComponent = ({
  selectedScheduleUser,
  setSelectedScheduleUser,
  setIncludeCalendarEvents,
  setIncludeHorseTasks,
  setIncludeBarnTasks,
  includeCalendarEvents,
  includeHorseTasks,
  includeBarnTasks,
  setSelectedBarnHorses,
  defaultBarnHorses,
  selectedBarnHorses,
  setTags,
  tags,
  setCurrentView,
  currentView,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  scheduleClick,
  weekStyle,
  setWeekStyle,
  navigate,
  allowChangeView,
  eventTemplatesFilter,
  setEventTemplatesFilter,
  selectedCalendarId,
  setSelectedCalendarId,
}) => {
  const dispatch = useDispatch();

  // eslint-disable-next-line no-unused-vars
  const smallDown = useMediaQuery(theme.breakpoints.down('sm'));
  const mediumDown = useMediaQuery(theme.breakpoints.down('md'));

  // React State
  const [openFilter, setOpenFilter] = React.useState(false);
  const [weekSettingsAnchorEl, setWeekSettingsAnchorEl] = React.useState(null);
  const openWeekSettingsMenu = Boolean(weekSettingsAnchorEl);

  // Redux State
  const selectedLocation = useSelector((state) => state.location.selectedLocation);
  const locations = useSelector((state) => state.location.locations);
  const barnUsersMap = useSelector((state) => state.barn.barnUsersMap);
  const isFetchingBoard = useSelector((state) => state.board.isFetchingBoard);
  const boardLocation = useSelector((state) => state.board.location);
  const allEventTemplates = useSelector((state) => state.eventTemplate.eventTemplates);
  const inlineDrawer = useSelector((state) => state.app.inlineDrawer);

  React.useEffect(() => {
    if (selectedBarnHorses && selectedBarnHorses.length > 0 && !defaultBarnHorses) {
      // If the board location changes, reset any filter horses
      setSelectedBarnHorses([])
    }
  }, [boardLocation])

  React.useEffect(() => {
    if (!selectedLocation.id && window.localStorage.getItem('barn_board_location') !== null
      && locations.content.find((l) => l.id === JSON.parse(window.localStorage.getItem('barn_board_location')).id)) {
      const newLocation = locations.content.find((l) => l.id === JSON.parse(window.localStorage.getItem('barn_board_location')).id);
      if (newLocation) {
        dispatch(setSelectedLocation(newLocation));
      }
    } else if (!selectedLocation.id && locations.length === 0) {
      dispatch(setSelectedLocation(locations[0]));
    }
  }, [locations]);

  const handleChangeLocation = (newLocation) => {
    if (newLocation && newLocation.id) {
      if (newLocation.timezone !== (selectedLocation && selectedLocation.timezone)) {
        // reset dates for timezone
        const timezoneOffsetMillis = getTimeZoneOffset(newLocation.timezone);
        setStartDate(new Date(startDate.getTime() + timezoneOffsetMillis))
        setEndDate(new Date(endDate.getTime() + timezoneOffsetMillis))
      }

      global.window.localStorage.setItem('barn_board_location', JSON.stringify(newLocation));
      global.window.localStorage.setItem('barn_board_location_location_board', null);
      dispatch(setSelectedLocation(newLocation));
    }
  };

  const handleClickWeekSettingsMenu = (event) => {
    setWeekSettingsAnchorEl(event.currentTarget);
  };
  const handleCloseWeekSettingsMenu = () => {
    setWeekSettingsAnchorEl(null);
  };

  return (
    <AppBar
      position="relative"
      color="inherit"
      sx={{
        background: '#fff',
        mb: 2,
      }}
      elevation={2}
    >
      <Container
        maxWidth="100%"
        sx={{
          pt: 1,
          pb: 0.5,
          height: '100%',
          overflow: 'hidden',
        }}
      >
        <Toolbar disableGutters variant="dense">
          <Box sx={{ width: '100%' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Grid container spacing={2} alignItems="center" sx={{ flexWrap: 'nowrap' }}>
                {
                  allowChangeView && (
                    <Grid item>
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          pr: 2,
                          borderRight: `1px solid ${blueGrey[100]}`,
                        }}
                      >
                        <ToggleButtonGroup
                          color="primary"
                          value={currentView}
                          exclusive
                          onChange={(e, newView) => setCurrentView(newView || currentView)}
                          aria-label="Task and Event View"
                        >
                          <ToggleButton size="small" value="grid"><Tooltip title="Planning Grid View"><CalendarViewMonth /></Tooltip></ToggleButton>
                          <ToggleButton size="small" value="calendar"><Tooltip title="Calendar View"><CalendarMonth /></Tooltip></ToggleButton>
                        </ToggleButtonGroup>
                      </Box>
                    </Grid>
                  )
                }
                {
                  !inlineDrawer && (
                    <Grid item sx={{ minWidth: 220 }}>
                      <LocationAutocomplete
                        multiple={false}
                        value={(selectedLocation && selectedLocation) || null}
                        onSelect={(e, newLocations) => {
                          handleChangeLocation(newLocations)
                        }}
                        limitTags={1}
                        size="small"
                        icon
                      />
                    </Grid>
                  )
                }
                <Grid
                  item
                  sx={{ flex: 1 }}
                >
                  <Box
                    sx={{
                      mr: 2,
                      flex: 1,
                      display: 'flex',
                      alignItems: 'center',
                      pl: !inlineDrawer && 2,
                      gap: 2,
                      borderLeft: !inlineDrawer && `1px solid ${blueGrey[100]}`,
                    }}
                  >
                    <TaskDefinitionAutocomplete
                      label="Task(s)"
                      size="small"
                      multiple
                      value={eventTemplatesFilter.filter((t) => t !== selectedCalendarId).map((id) => (allEventTemplates.find((et) => et.id === id) || {
                        id,
                        name: 'Unknown',
                      }))}
                      eventTemplates={null} // needs to be null so component uses all templates
                      onSelect={(e, taskDefinitions) => {
                        setEventTemplatesFilter(taskDefinitions.map((et) => et.id));
                        setSelectedCalendarId(null)
                      }}
                      includeEventTaskTypeTagId={false}
                      limitTags={2}
                      fullWidth
                      icon
                    />

                    <TaskDefinitionAutocomplete
                      label="Calendar"
                      id="planner-filter-calendar-autocomplete"
                      size="small"
                      multiple={false}
                      value={selectedCalendarId && allEventTemplates.find((et) => et.id === selectedCalendarId)}
                      eventTemplates={null} // needs to be null so component uses all templates
                      onSelect={(e, taskDefinition) => {
                        const newCalendarId = taskDefinition && taskDefinition.id;
                        setSelectedCalendarId(newCalendarId);
                        setEventTemplatesFilter(!newCalendarId
                          ? []
                          : [newCalendarId, ...((taskDefinition.children && taskDefinition.children.map((t) => t.id)) || [])])
                      }}
                      includeEventTaskTypeTagId
                      includeHorseTaskTypeTagId={false}
                      includeBarnTaskTypeTagId={false}
                      fullWidth
                      icon
                    />
                  </Box>
                </Grid>
              </Grid>
              {
                selectedLocation && selectedLocation.id && (
                  <Box
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flex: 1,
                    }}
                  >

                    <Grid item>
                      <Box
                        sx={{
                          borderLeft: `1px solid ${blueGrey[100]}`,
                          mr: 2,
                          pl: 2,
                          height: '100%',
                        }}
                      >
                        <Tooltip title="Show/Hide Filter">
                          <IconButton
                            onClick={(e) => { e.stopPropagation(); setOpenFilter(!openFilter); }}
                          >
                            {(openFilter
                              ? <FilterAltOff />
                              : <FilterAlt />)}
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </Grid>

                    <Box
                      sx={{
                        px: 2,
                        borderLeft: `1px solid ${blueGrey[100]}`,
                        height: '100%',
                      }}
                    >
                      {
                        (!mediumDown && !inlineDrawer)
                          ? (
                            <Button
                              color="primary"
                              variant="contained"
                              sx={{ width: 125 }}
                              startIcon={!smallDown && <Add />}
                              onClick={scheduleClick}
                            >Add Task
                            </Button>
                          )
                          : (
                            <IconButton
                              color="primary"
                              variant="contained"
                              onClick={scheduleClick}
                            ><Add />
                            </IconButton>
                          )
                      }
                    </Box>
                    <Box
                      sx={{
                        pl: 1,
                        borderLeft: `1px solid ${blueGrey[100]}`,
                      }}
                    >
                      {
                        isFetchingBoard
                          ? (
                            <CircularProgress
                              size={24}
                              sx={{
                                m: 1,
                                mr: 0,
                              }}
                            />
                          )
                          : (
                            <Tooltip title="Additional Settings">
                              <IconButton
                                sx={{ pr: 0 }}
                                onClick={handleClickWeekSettingsMenu}
                              ><Settings />
                              </IconButton>
                            </Tooltip>
                          )
                      }
                    </Box>
                  </Box>
                )
              }
            </Box>
            <Collapse in={openFilter}>
              <Divider sx={{ my: 1 }} />
              <Grid container spacing={1}>
                <Grid item sx={{ minWidth: 200 }}>
                  <BarnHorsesAutocomplete
                    multiple
                    value={selectedBarnHorses}
                    onSelect={(e, newHorses) => { setSelectedBarnHorses(newHorses) }}
                    limitTags={1}
                    barnHorses={undefined}
                    size="small"
                    label="Filter by horse"
                  />
                </Grid>
                <Grid item sx={{ minWidth: 200 }}>
                  <TagsAutocomplete
                    onSelect={(e, value) => { setTags(value) }}
                    value={tags}
                    size="small"
                    editMode={false}
                    limitTags={1}
                    label="Filter by tag"
                  />
                </Grid>
                <Grid item>
                  <Tooltip title="When a user is selected here, this user will be placed as the assigned user for tasks you schedule on this page.">
                    <Box
                      sx={{
                        mr: 2,
                        width: 225,
                        display: 'flex',
                        alignItems: 'center',
                        pl: 1,
                        borderLeft: `1px solid ${blueGrey[100]}`,
                      }}
                    >
                      <BarnUsersAutocomplete
                        label="Assigned User"
                        multiple={false}
                        value={selectedScheduleUser}
                        onSelect={(e, newBarnUser) => setSelectedScheduleUser(newBarnUser)}
                        limitTags={1}
                      />
                      <InfoOutlined
                        color="secondary"
                        sx={{
                          fontSize: 22,
                          ml: 0.5,
                        }}
                      />
                    </Box>
                  </Tooltip>
                </Grid>
                <Grid item>
                  <FormGroup row>
                    <FormControlLabel
                      sx={{
                        m: 0,
                        mr: 1.5,
                      }}
                      labelPlacement="start"
                      control={<Checkbox checked={includeCalendarEvents} onChange={(e) => setIncludeCalendarEvents(e.target.checked)} />}
                      label={(
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 300,
                            lineHeight: 1.25,
                          }}
                        >Calendar<br />Events
                        </Typography>
                      )}
                    />
                    <FormControlLabel
                      sx={{
                        m: 0,
                        mr: 1.5,
                      }}
                      labelPlacement="start"
                      control={<Checkbox checked={includeHorseTasks} onChange={(e) => setIncludeHorseTasks(e.target.checked)} />}
                      label={(
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 300,
                            lineHeight: 1.25,
                          }}
                        >Horse<br />Tasks
                        </Typography>
                      )}
                    />
                    <FormControlLabel
                      sx={{ m: 0 }}
                      labelPlacement="start"
                      control={<Checkbox checked={includeBarnTasks} onChange={(e) => setIncludeBarnTasks(e.target.checked)} />}
                      label={(
                        <Typography
                          variant="caption"
                          sx={{
                            fontWeight: 300,
                            lineHeight: 1.25,
                          }}
                        >Barn<br />Tasks
                        </Typography>
                      )}
                    />
                  </FormGroup>
                </Grid>
                {
                  mediumDown && (
                    <Grid item>
                      <Tooltip title="When a user is selected here, this user will be placed as the assigned user for tasks you schedule on this page.">
                        <Box
                          sx={{
                            width: 225,
                            display: 'flex',
                            alignItems: 'center',
                            pl: 2,
                            borderLeft: `1px solid ${blueGrey[100]}`,
                          }}
                        >
                          <BarnUsersAutocomplete
                            label="Default Assigned User"
                            multiple={false}
                            value={selectedScheduleUser}
                            onSelect={(e, newBarnUser) => setSelectedScheduleUser(newBarnUser)}
                            limitTags={1}
                          />
                          <InfoOutlined
                            color="secondary"
                            sx={{
                              fontSize: 22,
                              ml: 0.5,
                            }}
                          />
                        </Box>
                      </Tooltip>
                    </Grid>
                  )
                }
              </Grid>
            </Collapse>
          </Box>
        </Toolbar>
      </Container>

      <Menu
        anchorEl={weekSettingsAnchorEl}
        id="account-menu"
        open={openWeekSettingsMenu}
        onClose={handleCloseWeekSettingsMenu}
        transformOrigin={{
          horizontal: 'right',
          vertical: 'top',
        }}
        anchorOrigin={{
          horizontal: 'right',
          vertical: 'bottom',
        }}
      >
        <MenuItem onClick={() => { navigate('/settings/locations') }}>
          <Box sx={{ mr: 2 }}><HorseIcon color={brandColors.secondary[500]} sx={{ mr: 2 }} /></Box>Manage Horses At This Location
        </MenuItem>
        <Divider />
        {
          weekStyle === 'isoWeek'
            ? (
              <MenuItem onClick={() => { setWeekStyle('week'); handleCloseWeekSettingsMenu(); }} selected={weekStyle === 'week'}>
                <Box sx={{ mr: 2 }}><CalendarViewWeek color="secondary" /></Box>Change Week Display to Sunday - Saturday
              </MenuItem>
            )
            : (
              <MenuItem onClick={() => { setWeekStyle('isoWeek'); handleCloseWeekSettingsMenu(); }} selected={weekStyle === 'isoWeek'}>
                <CalendarViewWeek color="secondary" sx={{ mr: 2 }} />Change Week Display to Monday - Sunday
              </MenuItem>
            )
        }
        <Divider />

        <MenuItem onClick={() => { navigate(`/settings/locations?locationId=${selectedLocation.id}`) }} selected={weekStyle === 'isoWeek'}>
          <Box sx={{ display: 'flex' }}>
            <AssignmentInd color="secondary" sx={{ mr: 2 }} />
            <Box>
              <Box>
                Manage Assigned Planner & Reminder Notifications
              </Box>
              <Box>
                {
                  selectedLocation.assignedPlanner && (
                    getBarnUsersForAssignmentString(selectedLocation.assignedPlanner, barnUsersMap).map((user) => (
                      <User
                        key={user.auth0UserId}
                        chip
                        user={user}
                        disableGutters
                      />
                    ))
                  )
                }
              </Box>
            </Box>

          </Box>
        </MenuItem>
      </Menu>
    </AppBar>
  );
};

FilterBarComponent.propTypes = {
  selectedScheduleUser: PropTypes.any,
  setSelectedScheduleUser: PropTypes.func.isRequired,
  setIncludeCalendarEvents: PropTypes.func.isRequired,
  setIncludeHorseTasks: PropTypes.func.isRequired,
  setIncludeBarnTasks: PropTypes.func.isRequired,
  includeCalendarEvents: PropTypes.bool.isRequired,
  includeHorseTasks: PropTypes.bool.isRequired,
  includeBarnTasks: PropTypes.bool.isRequired,
  setSelectedBarnHorses: PropTypes.func.isRequired,
  selectedBarnHorses: PropTypes.array.isRequired,
  defaultBarnHorses: PropTypes.array,
  setTags: PropTypes.func.isRequired,
  tags: PropTypes.array.isRequired,
  setCurrentView: PropTypes.func.isRequired,
  currentView: PropTypes.string.isRequired,
  startDate: PropTypes.any.isRequired,
  endDate: PropTypes.any.isRequired,
  setStartDate: PropTypes.func.isRequired,
  setEndDate: PropTypes.func.isRequired,
  scheduleClick: PropTypes.func.isRequired,
  weekStyle: PropTypes.string.isRequired,
  setWeekStyle: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired,
  allowChangeView: PropTypes.bool.isRequired,
  eventTemplatesFilter: PropTypes.any.isRequired,
  setEventTemplatesFilter: PropTypes.func.isRequired,
  selectedCalendarId: PropTypes.any,
  setSelectedCalendarId: PropTypes.func.isRequired,
};

FilterBarComponent.defaultProps = {
  selectedScheduleUser: null,
  defaultBarnHorses: null,
  selectedCalendarId: null,
};

export default (FilterBarComponent);

